import { Routes, Route } from 'react-router-dom';
import { HomePage, PrivacyPolicy, Terms, DownloadPage } from '../pages';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/download" element={<DownloadPage />} />
    </Routes>
  );
}

export default App;


